import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { HealthAppService } from 'src/app/services/explore-health/health-app.service';
import { DetailDatasetViewComponent } from './detail-dataset-view/detail-dataset-view.component';
import { HttpResponse } from '@angular/common/http';
import { SnackbarService } from 'src/app/services/common/snackbar.service';
import { LoaderService } from 'src/app/components/loader/loader.service';

@Component({
  selector: 'app-table-view',
  templateUrl: './table-view.component.html',
  styleUrl: './table-view.component.scss',
})
export class TableViewComponent {
  responseFound: boolean = true;
  loading: boolean = true;
  metaFiles: any = [];
  dataFiles: any = [];
  datasetDetails: any;

  currentTableDetails: any;

  constructor(
    public haService: HealthAppService,
    @Inject(MAT_DIALOG_DATA) public dataSet: any,
    public dialogRef: MatDialogRef<TableViewComponent>,
    private readonly dialog: MatDialog,
    private readonly loader: LoaderService,
    private readonly snack: SnackbarService
  ) {}

  table_index: number = 0;
  head: any = [];

  ngOnInit(): void {
    this.onViewData(this.dataSet.id, this.table_index);
  }

  onViewData(dataset_id: any, table_index: any) {
    this.haService.getDataSetforDataCatalogue(dataset_id).subscribe({
      next: (response: any) => {
        if (response) {
          this.responseFound = true;
          this.datasetDetails = response;
          this.loading = false;
          this.onTableHeadingClick(table_index);
        } else {
          this.responseFound = false;
          this.datasetDetails = null;
          this.loading = false;
        }
      },
      error: (error: any) => {
        this.responseFound = false;
      },
    });
  }

  getCheckedValue() {
    return this.datasetDetails?.metadata[this.table_index]?.sqltablename ?? '';
  }

  onTableHeadingClick(table_index: number) {
    this.table_index = table_index;
    this.head = [];
    this.metaFiles = [];
    this.dataFiles = [];
    try {
      if (this.datasetDetails?.files.length > 0) {
        this.dataFiles = this.datasetDetails.files.filter(
          (file: any) => file.filetype === 'data'
        );
        this.metaFiles = this.datasetDetails.files.filter(
          (file: any) => file.filetype === 'metadata'
        );
      }

      const tableDetails =
        this.datasetDetails?.metadata?.[table_index]?.sqlmetadata ?? [];
      if (tableDetails?.length > 0) {
        this.currentTableDetails = JSON.parse(tableDetails);

        if (this.currentTableDetails?.data?.length > 0) {
          Object.keys(this.currentTableDetails.data[0]).forEach(
            (key: any, index: number) => {
              this.head.push(key);
            }
          );
        }
      }
    } catch (error) {
      console.log('Error:', error);
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  onViewColumn() {
    let dialogRef = this.dialog.open(DetailDatasetViewComponent, {
      hasBackdrop: false,
      disableClose: true,
      autoFocus: false,
      backdropClass: 'backdropBackground',
      data: {
        tableDetails: this.currentTableDetails,
        tableName: this.getTableName(
          this.datasetDetails?.metadata[this.table_index]?.sqltablename ??
            'Table Name'
        ),
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {});
  }

  getTableName(tableName: string) {
    return tableName?.replaceAll('[', '').replaceAll(']', '') ?? '';
  }

  downloadFile(file: any) {
    this.loader.showLoader();
    this.haService.downloadocument(file.fileurl).subscribe({
      next: (response: HttpResponse<ArrayBuffer>) => {
        this.loader.hideLoader();
        const fileName = file.filename ?? 'downloaded-file';
        const mimeType =
          response.headers.get('Content-Type') ??
          this.getMimeTypeFromFileName(fileName) ??
          'application/octet-stream';

        const blob = new Blob([response.body!], { type: mimeType });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (err) => {
        this.loader.hideLoader();
        console.error('File download failed:', err);
        this.snack.openErrorBar('Unable to download file');
      },
    });
  }

  private getMimeTypeFromFileName(fileName: string): string | null {
    const extensionRegex = /\.([0-9a-z]+)(?:[\?#]|$)/i;
    const extensionMatch = extensionRegex.exec(fileName);
    const extension = extensionMatch ? extensionMatch[1].toLowerCase() : null;

    switch (extension) {
      case 'pdf':
        return 'application/pdf';
      case 'doc':
        return 'application/msword';
      case 'docx':
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      case 'xls':
        return 'application/vnd.ms-excel';
      case 'xlsx':
        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      case 'csv':
        return 'text/csv';
      default:
        return null;
    }
  }
}
